import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "reactstrap";

const DashBoardNavbar = (props) => {
  const user = props.user;
  const urlPath = window.location.pathname;
  const pname = urlPath.substring(1);
  const navigate = useNavigate();
  const logOut = () => {
    sessionStorage.clear();
    // navigate('/login')
    
    // navigate("../login", {replace: true });

    navigate(0)

  }

  return (
    <nav
      className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl "
      id="navbarBlur"
      data-scroll="true"
    >
      <div className="container-fluid py-1 px-3">
        <nav className="breadcrumb d-flex justify-content-between" >
          <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
            <li className="breadcrumb-item text-sm">
              {/* eslint-disable-next-line */}
              <a className="opacity-5 text-dark" href="javascript:;">
                Pages
              </a>
            </li>
            <li
              className="breadcrumb-item text-sm text-dark active"
              aria-current="page"
            >
              {pname.charAt(0).toUpperCase() + pname.slice(1)}
            </li>
          </ol>

        </nav>
        <div>

          <button type="button" onClick={logOut} class="btn btn-danger btn-md px-5 opacity-75">Log Out</button>

        </div>
      </div>
    </nav>
  );
};
export default DashBoardNavbar;
